import * as type from '../actions/types';

const initialState = {
  pending: false,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.UPDATE_OBEE_GUEST_PENDING:
      return {
        ...state,
        pending: true,
        error: null,
      };
    case type.UPDATE_OBEE_GUEST_SUCCESS:
      return {
        ...state,
        pending: false,
        error: null,
      };
    case type.UPDATE_OBEE_GUEST_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
